export const audienceSelector = state => state.audience;
export const selectedMenuItemNameSelector = state =>
  state.audience.selectedMenuItemName;
export const selectedTopicsListSelector = state =>
  state.audience.selectedTopicsList;
